import { useEffect, useRef, useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import './Footer.css';

function Footer({ menuCollapse, isLoginPage }) {
    const footerRef = useRef(null);
    // Mobile/tablet only — see Footer.css: the toggle button and the
    // collapsed state are both scoped to the max-width: 1024px media query,
    // so on desktop the disclaimer text always renders fully regardless of
    // this state.
    const [isDisclaimerExpanded, setIsDisclaimerExpanded] = useState(true);

    // The footer is position:fixed and its disclaimer text can wrap to a
    // different number of lines per page/device, so its real height isn't
    // knowable in CSS alone. Measure it live and publish it as a CSS
    // variable so the scrollable content area (see Layout.css) can reserve
    // exactly that much space — no overlap, and no wasted leftover gap on
    // pages where the footer happens to be shorter.
    useEffect(() => {
        const node = footerRef.current;
        if (!node) return undefined;

        const publishHeight = () => {
            document.documentElement.style.setProperty('--footer-height', `${node.offsetHeight}px`);
        };
        publishHeight();

        const observer = new ResizeObserver(publishHeight);
        observer.observe(node);
        return () => observer.disconnect();
    }, []);

    // Mobile/tablet only (desktop never gets this class — see the button's
    // display: none default in Footer.css): collapsing the text lets the
    // footer itself shrink down to a compact bar instead of keeping the
    // full-paragraph min-height around empty space.
    const isCollapsedOnSmallScreen = !isDisclaimerExpanded;

    // Login and Disclaimer render outside the normal content wrapper (see
    // Layout.jsx's isLoginPage branch) specifically so there's no sidebar/
    // footer chrome around them — showing an empty footer bar there defeats
    // that. The full disclaimer footer comes back once the user has
    // consented and lands on an authenticated page.
    if (isLoginPage) {
        return null;
    }

    return (
        <footer ref={footerRef} className={`app-footer ${menuCollapse ? "footer-collapse-wrapper" : "footer-main-wrapper"} ${isCollapsedOnSmallScreen ? 'footer-disclaimer-collapsed' : ''}`}>
            <div className="container-fluid">
                <div className="row align-items-center">
                    {/* <div className='col-4'></div>
                    <div className='col-4 primary-font d-flex align-items-center'>Copyright © Lateetud 2025 | All Rights Reserved</div>
                    <div className='col-4 primary-font d-flex align-items-center justify-content-end'>
                        Powered By
                        <img className="ms-2" src="/assets/logos/FooterLogo.png" width="140" alt="Lateetud" />
                    </div> */}
                    <div className="col-md-11 primary-font text-left mx-auto footer-disclaimer-wrapper">
                            <div className={`footer-disclaimer-text ${isDisclaimerExpanded ? '' : 'collapsed'}`}>
                                Radiology Partners Holdings, LLC ("RPH") makes no representations related to any figures listed in this investor portal, any current or future value of a preferred unit of RPH or of your equity interests in RPH, or the amount of proceeds, if any, that you might receive. Your equity interests in RPH are subject in all respects to the terms and conditions of the RPH limited liability company agreement and the terms and conditions of your award documents, in each case as in effect from time to time.
                            </div>
                            <button
                                type="button"
                                className={`footer-disclaimer-toggle ${isDisclaimerExpanded ? 'is-expanded' : 'is-collapsed'}`}
                                onClick={() => setIsDisclaimerExpanded(prev => !prev)}
                                aria-expanded={isDisclaimerExpanded}
                                aria-label={isDisclaimerExpanded ? 'Hide disclaimer' : 'Show disclaimer'}
                            >
                                {/* Icon-only while expanded; while collapsed there's no
                                    paragraph left on screen to hint what the icon does,
                                    so a label is shown alongside it. */}
                                {!isDisclaimerExpanded && <span className="footer-disclaimer-toggle-label">Show disclaimer</span>}
                                {isDisclaimerExpanded ? <FiChevronDown /> : <FiChevronUp />}
                            </button>
                        </div>

                    {/* <div className="col-md-2 primary-font d-flex align-items-center justify-content-md-end justify-content-center mt-2 mt-md-0" style={{ whiteSpace: 'nowrap' }}>
                        Powered By
                        <img className="ms-2" src="/assets/logos/FooterLogo.png" width="120" alt="Lateetud" />
                    </div> */}
                </div>
            </div>
        </footer>
    )
}

export default Footer